import React, { useEffect } from 'react';
import { Select, MenuItem, FormControl, InputLabel, FormHelperText, Checkbox, ListItemText } from '@mui/material';
import { Controller } from 'react-hook-form';

const ComplexSelect = React.forwardRef(({
  name,
  label,
  defaultValue = [], // Default value as an array for multi-select
  data, // Array of objects with keys for value and display
  error,
  control,
  rules,
  variant = "outlined",
  margin = "dense",
  onChange: onChangeFromParent,
  valueKey, // The key to be used for the value
  displayKey, // The key to be used for the display text
  separator = ' - ',
  disabled = false,
  multiple = false, // Flag to enable multi-select
  isMultiColumn = false,
  sx,
  ...props
}, ref) => {

  useEffect(() => { }, [data, control]);

  const getLabel = (item) => {
    if (!item) {
      // If item is undefined or null, return an empty string or placeholder
      return '';
    }

    if (Array.isArray(displayKey)) {
      return displayKey.map(field => item[field]).join(separator);
    }
    return item[displayKey] ?? "";
  };

  return (
    <FormControl
      fullWidth
      size="small"
      variant={variant}
      margin={margin}
      sx={sx?.formControl}
      error={!!error}>
      <InputLabel id={`${name}-label`}>
        {label}
      </InputLabel>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => {
          const currentValue = multiple
            ? (field.value || []).filter(value => data.some(item => item[valueKey] == value))
            : data.some(item => item[valueKey] == field.value)
              ? field.value
              : ''; // Handle missing value for single select


          return (
            <Select
              {...field}
              ref={ref}
              value={currentValue}
              labelId={`${name}-label`}
              label={label}
              disabled={disabled}
              multiple={multiple}
              renderValue={(selected) => {
                if (!multiple) {
                  const selectedItem = data.find(item => item[valueKey] === selected);
                  return selectedItem ? getLabel(selectedItem) : '';
                }
                return selected.map(value => {
                  const item = data.find(i => i[valueKey] === value);
                  return item ? getLabel(item) : value;
                }).join(', ');
              }}
              onChange={(event) => {
                const value = event.target.value;
                field.onChange(value);
                if (onChangeFromParent) {
                  onChangeFromParent(value);
                }
              }}
            >
              {data.map((item) => (
                <MenuItem key={item[valueKey]} value={item[valueKey]}>
                  {multiple && <Checkbox checked={field.value?.includes(item[valueKey])} />}
                  <ListItemText primary={getLabel(item)} />
                </MenuItem>
              ))}
            </Select>
          );
        }}
      />
      {error && <FormHelperText>{error.message}</FormHelperText>}
    </FormControl>
  );
});

export default ComplexSelect;